import type { Dependency } from '@wendellhu/redi';
import { CaseController } from './case.controller';
import { CaseService } from './case.service';
import { ICaseRepository } from './interfaces/case.repository.interface';
import { CaseRepository } from './repositories/case.repository';

export const CaseBackendModule = {
  providers: [
    [CaseController],
    [CaseService],
    [ICaseRepository, { useClass: CaseRepository }],
  ] satisfies Dependency[],
  imports: [],
};
